export const API_BASE_URL =
  process.env.VERCEL_ENV === 'preview'
    ? `https://${process.env.NEXT_PUBLIC_SHA?.substring(0, 7)}-preview.api.fireworks.ai`
    : process.env.VERCEL_GIT_COMMIT_REF === 'dev'
      ? `https://dev.api.fireworks.ai`
      : process.env.VERCEL_GIT_COMMIT_REF === 'preview'
        ? `https://preview.api.fireworks.ai`
        : process.env.NEXT_PUBLIC_BASE_API_URL ?? `https://api.fireworks.ai`;

export const GATEWAY_URL = process.env.NEXT_PUBLIC_GATEWAY_URL ?? 'https://gateway.fireworks.ai/web';

const gatewayURLValue = new URL(GATEWAY_URL);
export const GATEWAY_BASE_URL = `${gatewayURLValue.protocol}//${gatewayURLValue.host}`;

export const IS_NODE_POOL_UI_ENABLED =
  process.env.NEXT_PUBLIC_IS_NODE_POOL_UI_ENABLED === undefined
    ? undefined
    : process.env.NEXT_PUBLIC_IS_NODE_POOL_UI_ENABLED === 'true';

export const GRAFANA_HOST =
  process.env.NEXT_PUBLIC_GRAFANA_HOST === undefined
    ? 'grafana-dev.fireworks.ai'
    : process.env.NEXT_PUBLIC_GRAFANA_HOST;

const defaultBaseUrl = process.env.NEXT_PUBLIC_VERCEL_URL
  ? `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
  : process.env.NEXT_PUBLIC_LOCAL_SERVER ?? 'http://localhost:3000';

let baseURLInternal: string;
switch (process.env.NEXT_PUBLIC_VERCEL_ENV) {
  case 'production':
    baseURLInternal = 'https://fireworks.ai';
    break;
  case 'preview':
    switch (process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF) {
      case 'preview':
        baseURLInternal = 'https://preview.fireworks.ai';
        break;
      case 'dev':
        baseURLInternal = 'https://dev.fireworks.ai';
        break;
      default:
        baseURLInternal = defaultBaseUrl;
        break;
    }
    break;
  default:
    baseURLInternal = defaultBaseUrl;
    break;
}

export const BASE_URL = baseURLInternal;
